import { render } from "./TheNavigation.vue?vue&type=template&id=aee274e4&scoped=true"
import script from "./TheNavigation.vue?vue&type=script&lang=js"
export * from "./TheNavigation.vue?vue&type=script&lang=js"

import "./TheNavigation.vue?vue&type=style&index=0&id=aee274e4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-aee274e4"

export default script